import {COMMON_BUILDING_TOKENS} from "../../constants/tokens";
import {checkIfCentralQuarter} from "./checkIfCentralQuarter";

export const checkIfAnyQuarter = (tokenId) => {
  if (!tokenId) {
    return false;
  }

  return tokenId === COMMON_BUILDING_TOKENS.QUARTER || checkIfCentralQuarter(tokenId);
}